import   React                     ,
       { useState                  ,
	     useEffect                 ,
         useCallback               }  from 'react';

import   classNames                   from 'classnames';
import   CreationIp                   from '../../widget/dataDisplay/labels/CreationIp';

import   styles                       from './SalesCampaignSheet.module.scss';

import   Field                        from '../../widget/inputs/Field';
import   FieldCalendar                from '../../widget/inputs/FieldCalendar';
import   Toggle                       from '../../widget/inputs/Toggle';
import   Trigger                      from '../../widget/actuators/Trigger';
import   WidgetFrame                  from '../../widget/navigation/WidgetFrame';
import   Window                       from '../../widget/windows/window';

import   SalesCampaignSheet_Action    from './SalesCampaignSheet_Action';

import { Media                     ,
         MediaCategory             }  from '../../../dataTypes/mediaManagment/types';
		 
import { Product                   ,
         ProductCategory           }  from '../../../dataTypes/productManagment/types';
		 

import { SalesCampaign             ,
         initializedSalesCampaign  ,
		 SalesAction               ,
         initializedSalesAction    }  from '../../../dataTypes/salesCampaignManagment/types';
		 
import { compareSalesCampaign      }  from '../../../dataTypes/salesCampaignManagment/utils';


import { convertStringToDate       ,
         convertDateToString     }  from '../../../dataTypes/timeManagment/utils';
		 
import { createSalesCampaign       ,
         updateSalesCampaign       }  from '../../../backendServices/salesCampaignManagment/api_salesCampaign';

import { useTypedSelector          }  from '../../../store/useTypeSelector';
import { RootState                 }  from '../../../store/generalReducer';

export interface SalesCampaignSheetProps {
  medias                 : Media[]             ;
  mediaCategories        : MediaCategory[]     ;
  products               : Product[]           ;
  productCategories      : ProductCategory[]   ;
  existingSalesCampaigns : SalesCampaign []    ; 
  salesCampaign?         : SalesCampaign       ;
  onCreate?              : (id:number) => void ;
  onEdit?                : (id:number) => void ;
}

export const SalesCampaignSheet = ({ medias                 ,
                                     mediaCategories        ,
                                     products               ,
                                     productCategories      ,
									 existingSalesCampaigns ,
                                     salesCampaign          ,
                                     onCreate               ,
                                     onEdit                 }: SalesCampaignSheetProps) => {

  const isEditMode = salesCampaign !== undefined;

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);

  const initialSalesCampaign: SalesCampaign = isEditMode ? salesCampaign! : initializedSalesCampaign();


  const [ id                     ] = useState ( initialSalesCampaign.id              );
  const [ creationDate           ] = useState ( initialSalesCampaign.creationDate    );
  const [ active                 , setActive                 ] = useState ( initialSalesCampaign.active          );
  const [ activeScheduled        , setActiveScheduled        ] = useState ( initialSalesCampaign.activeScheduled );
  const [ name                   , setName                   ] = useState ( initialSalesCampaign.name            );
  const [ beginningDate          , setBeginningDate          ] = useState ( initialSalesCampaign.beginningDate   );
  const [ endingDate             , setEndingDate             ] = useState ( initialSalesCampaign.endingDate      );
  const [ salesActions           , setSalesActions           ] = useState ( initialSalesCampaign.salesActions    );
 
  const [ nameErrorMessage          , setNameErrorMessage          ] = useState ( '' );
  const [  , setBeginningDateErrorMessage ] = useState ( '' );
  const [     , setEndingDateErrorMessage    ] = useState ( '' );
  const [ showErrorMessages         , setShowErrorMessages         ] = useState  ( false );

  const [ fieldsAreModified         , setFieldsAreModified         ] = useState ( false );

  const [ saved                  , setSaved                  ] = useState  ( false );
  const [ cancelation            , setCancelation            ] = useState  ( false );
//  const [ salesCampaignSheetId   , setSalesCampaignSheetId   ] = useState              (   0   );

  let salesCampaignSheetId:number = 0

  const [ checkError             , setCheckError             ] = useState  ( false );
  const [ apiError               , setApiError               ] = useState  ( false );

  const [ version                , setVersion                ] = useState  (0)
  const [ progress               , setProgress               ] = useState  (0);

  const [ saveButtonLock         , setSaveButtonLock         ] = useState  ( false )

  const [ openActions            , setOpenActions] = useState(() => {
    const initialOpenActions: Record<number, boolean> = {};
    salesActions.forEach((_, index) => {
      initialOpenActions[index] = true;
    });
    return initialOpenActions;
  });

  useEffect(() => {
	  
	setFieldsAreModified ( !compareSalesCampaign ( initialSalesCampaign, active, name, beginningDate, endingDate, salesActions) )

  }, [active, name, beginningDate, endingDate, salesActions]);



  const checkParams = (): boolean => {
	  
	const test1 = name !== ''
	const test2 = !activeScheduled || (activeScheduled && beginningDate !== null)
	const test3 = !activeScheduled || (activeScheduled && endingDate    !== null)
	let   test4 = true
	
	for ( let i=0 ; i<salesActions.length ; i++ )
	 {
	  const regex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

	  test4 = test4 && 
	          salesActions[i].mediaId   !==  0 && 
			//  salesActions[i].productId !==  0 && 
	          salesActions[i].timecode  !== '' && 
			  salesActions[i].duration  !== '' && 
			  regex.test(salesActions[i].timecode) && 
			  regex.test(salesActions[i].duration)
	 }

    if ( !test1 ) 
	      {
		   setNameErrorMessage ( 'Il manque le nom' )
          }
	 else {
		   setNameErrorMessage ( '' )
	      }
		  
	if ( !test2 )
	      {
	       setBeginningDateErrorMessage ( 'Il manque la date de début' ) 
		  }
	 else {
	       setBeginningDateErrorMessage ( '' ) 
	      }
	 
	if ( !test3 )   
	      {
		   setEndingDateErrorMessage    ( 'Il manque la date de fin' )
		  }
     else {	
	       setEndingDateErrorMessage    ( '' )
	      }
		  
    if ( !test4 ) 
	 { 
      setShowErrorMessages ( true ) 
	  setVersion ( version+1 )      
     }
		
   console.log ( 'checkParams : ', test1, test2, test3, test4)		
		
   return test1 && test2 && test3 && test4
  }

  const save = async () => {

    if ( checkParams() )
	      {
		   setCheckError        (false)
		   setShowErrorMessages (false)
           setProgress          (0);
           setSaved             (false);

           const result = isEditMode ? await updateSalesCampaign (id, name , active, activeScheduled, beginningDate, endingDate , salesActions, setProgress) :
                                       await createSalesCampaign (    name , active, activeScheduled, beginningDate, endingDate , salesActions, setProgress, authentication.admin?.id)

		   console.log (result)	  

                if ( result.code === 1 )
                 {
                  const salesCampaignIdToShow = isEditMode ? id : result.payload
                  salesCampaignSheetId = salesCampaignIdToShow
              //  setSalesCampaignSheetId ( salesCampaignIdToShow )
                  setSaved    (true); // On arrête d'afficher la progression
                  setProgress (0)
                  setApiError (false);
		          setFieldsAreModified (false);
 	             }

           else if ( result.code < 1)
                 {
                  setSaved    (true); 
                  setProgress (0)
                  setApiError (true);
                 }
	      }
 	 else {
		   setCheckError (true)
	      }
  }

  const handleActiveChange = (newValue: boolean ) => {
  
    setActive(newValue);
  }

  const handleActiveScheduledChange = ( newState: boolean , id?: number | undefined) => {

    setActiveScheduled (newState)
  }
  
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
  
    setName(e.target.value);
  };

  const handleBeginningDateChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
  
    setBeginningDate ( convertStringToDate (e.target.value , 'dd/MM/yyyy HH:mm') )
  }

  const handleEndingDateChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
  
    setEndingDate ( convertStringToDate (e.target.value , 'dd/MM/yyyy HH:mm') )
  }

 const generateRandomLargeNumber = (): number => {
  const min = 10_000_000_001;         // borne minimale exclusive
  const max = 999_999_999_999;        // borne maximale (par exemple 12 chiffres)
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

  const handleAddSalesAction = () => {
  
    const newAction = initializedSalesAction()
	newAction.id = generateRandomLargeNumber()

    const newSalesActions = [...salesActions, newAction]
	
    setSalesActions(newSalesActions);

    setOpenActions((prev) => ({
      ...prev,
      [salesActions.length]: true,
    }));

  }

  const handleDeleteSalesAction = (index: number) => {
  
    const newSalesActions = salesActions.filter((_, i) => i !== index);

    setSalesActions(newSalesActions);
  }

const handleSalesActionChange = useCallback((salesAction: SalesAction, index: number) => {

  setSalesActions(prev => {
    // Éviter de créer un nouveau tableau si rien n'a changé
    if (prev[index] === salesAction) return prev;
    
    const newSalesActions = [...prev];
    newSalesActions[index] = salesAction;

    return newSalesActions;
  });
}, []); // Dépendances vides car on utilise la forme fonctionnelle



  const handleSaveButton = () => {

    if ( !saveButtonLock )
     {
      setSaveButtonLock (true)
      save ()
     }
     else {console.log ("LOCK")}
  }

  const handleValidButton2 = () => {

    setSaved (false)
    setProgress (0)
    setSaveButtonLock (false)

    if ( isEditMode )
          {
           if ( onEdit )
            {
             onEdit ( salesCampaignSheetId )
            }
          }
     else {
           if ( onCreate )
            {
             onCreate ( salesCampaignSheetId )
            }
          }
  }


  const handleErrorAckButton = () => {

    setSaved (false)
    setProgress (0)
    setSaveButtonLock (false)
    window.scroll(0, 0);
  }

  const handleCancelButton2 = () => {

    setCancelation (false)
    setSaved (false)
    setProgress (0)
    setSaveButtonLock (false)
    window.scroll(0, 0);
  }

  const handleSalesCampaingCreationAckButton = () => {

    setCancelation (false)

    if ( isEditMode )
          {
           if ( onEdit )
            {
             onEdit ( 0 )
            }
          }
     else {
           if ( onCreate )
            {
             onCreate ( 0 )
            }
          }
  }

  const handleCancelButton3 = () => {

    setCancelation (true)
  }

  const handleCheckErrorAckButton = () => {
	  
	setCheckError (false) 
    setSaveButtonLock (false)
  }

  return (

           <div className={classNames(styles.root)}>

             {
              checkError &&
              <Window message                 = {<>La fiche comporte des erreurs</>}
                      messageType             = "information"
                      onClickOnValidateButton = {handleCheckErrorAckButton} 
                      validButtonText         = "Ok"					  />
             }

             {
              !saved && (progress > 0) &&
              <Window message     = {<>Les éléments de la fiche sont en cours d'upload<br/>{`${progress}%`} effectués</>}
                      messageType = "information" 
                      validButtonText         = "Ok"										  />
             }

             {
              saved && apiError &&
              <Window message                 = {<>Une erreur est survenue lors de la création de la fiche</>}
                      messageType             = "information"
                      onClickOnValidateButton = {handleErrorAckButton} 
                      validButtonText         = "Ok"					  />
             }

             {
              saved && !apiError &&
              <Window message                 = { isEditMode ? <>Campagne modifiée</> : <>Campagne créée</>}
                      messageType             = "information"
                      onClickOnValidateButton = {handleSalesCampaingCreationAckButton}  
                      validButtonText         = "Ok"    					  />
             }

             {/*
              saved && !error &&
              <Window message                 = {<>Fiche créée<br/>Voulez-vous créer une autre fiche ?</>}
                      messageType             = "question"
                      onClickOnCancelButton   = {handleCancelButton}
                      onClickOnValidateButton = {handleValidButton}  
                      validButtonText         = "Oui"
                      cancelButtonText        = "Non"    					  />
             */}
			 
             {
              cancelation &&
              <Window message                 = {<>Etes-vous sûr de vouloir annuler vos saisies ?</>}
                      messageType             = "question"
                      onClickOnCancelButton   = {handleCancelButton2}
                      onClickOnValidateButton = {handleValidButton2}  
                      validButtonText         = "Oui"
                      cancelButtonText        = "Non"    			  />
             }

             <div className={classNames(styles.contain)}>

                <div className={classNames(styles.form)}>

                 {
				  isEditMode &&
				  <div className={classNames(styles.salesCampaignId)}>
					{`Id : ${id}`}
                  </div>
				 }

                 {
				  isEditMode &&
				  <div className={classNames(styles.creationDate)}>
					{`Date de création : ${convertDateToString (creationDate,'dd/MM/yyyy HH:mm')}`}
					<CreationIp ipAddress = {initialSalesCampaign.creationIpAddress} />
                  </div>
				 }

          <div className = {classNames(styles.active)}>
            <WidgetFrame name               = "Actif :"
                         labelTextPosition  = "right"
                         labelBlockPosition = "left"
                         classNameGrid      = {classNames(styles.grid_frame)} >
              <Toggle checked  = {active}
                      form     = "switch"
                      onChange = {handleActiveChange}/>
            </WidgetFrame>
          </div>

          {
           active &&
           ( 
            <>
              <div className={classNames(styles.activeScheduled)}>
                <Toggle form    = "switch"
                        checked = {activeScheduled}
                        textOn  = "Programmé"
                        textOff = "Immédiat"
                        show    = "text"
                        fillColorOn = "#6632FF"
                        fillColorOff = "#6632FF"
                        internalPosition = {false}
                        persistentIcons = {true} 
                        onChange = {handleActiveScheduledChange} />
              </div>

              {
               activeScheduled && 
               (
                <>
                 <div className={classNames(styles.activeStartDate)}>
                    <WidgetFrame name                  = "Date et heure de début"
                                 labelTextPosition     = "center"
                                 labelBlockPosition    = "bottom"
                                 childrenBlockPosition = "center"
                                 classNameGrid         = {classNames(styles.grid_frame)} >
                      <FieldCalendar value      = {beginningDate ? convertDateToString (beginningDate, 'dd/MM/yyyy HH:mm') : ''}
                                     onChange   = {handleBeginningDateChange}
                                     showHours  = {true}
                                     checkInput = {false}
                                     width      = "187px"
                                     dateFormat = 'dd/MM/yyyy HH:mm'/>
                   </WidgetFrame>
                 </div>
                 <div className={classNames(styles.activeEndDate)}>
                    <WidgetFrame name                  = "Date et heure de fin"
                                 labelTextPosition     = "center"
                                 labelBlockPosition    = "bottom"
                                 childrenBlockPosition = "center"
                                 classNameGrid         = {classNames(styles.grid_frame)} >
                      <FieldCalendar value      = {endingDate ? convertDateToString (endingDate, 'dd/MM/yyyy HH:mm') : ''}
                                     onChange   = {handleEndingDateChange}
                                     showHours  = {true}
                                     checkInput = {false}
                                     width      = "187px"
                                     dateFormat = 'dd/MM/yyyy HH:mm'/>
                   </WidgetFrame>
                 </div>
                </>
               )
              }
            </>
           )
          }





                  <div className={classNames(styles.name)}>
					<WidgetFrame name               = "Nom de la campagne :"
                                 error              = {nameErrorMessage}
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid={classNames(styles.grid_frame)} >

				      <Field type     = "text" 
					         value    = {name} 
							 onChange = {handleNameChange} />

				    </WidgetFrame>
                  </div>


				  <div className={classNames(styles.salesAction)}>
					<WidgetFrame name               = "QR code :"
                                 error              = ""
   					 		     labelTextPosition  = "right"
							     labelBlockPosition = "left"  
								 classNameGrid      = {classNames(styles.grid_frame)} >

                      <div className = {classNames(styles.bloc)}>
                        {
  salesActions.map((salesAction, index) => {
    // Mémoïser le titre pour éviter les re-renders du CollapsiblePanel
    const actionTitle = `QR code n°${index + 1} (${salesAction.active ? "actif" : "inactif"})`;
    
    return (
      <div key={`action-wrapper-${index}-${salesAction.id}`} 
           className={classNames(styles.salesActionWrapper)}>
        
        <SalesCampaignSheet_Action 
          key={`action-${index}-${salesAction.id}`}
          isEditMode={isEditMode}
          salesAction={salesAction}
          medias={medias}
          mediaCategories={mediaCategories}
          existingSalesCampaigns={existingSalesCampaigns}
          title={actionTitle}
          onChange={(act) => handleSalesActionChange(act, index)}
          onDelete={() => handleDeleteSalesAction(index)}
          open={openActions[index] ?? undefined}
          name={`QR code n°${index + 1}`}
          showErrorMessages={showErrorMessages}
          version={version} 
        />
      </div>
    );
  })
}
                        <Trigger name="Ajouter un QR code / &quot;Click To Action&quot;"  onClick={handleAddSalesAction} variant="tailwind2" />
                      </div>
			  
				    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.buttons)}>

                    <div className={classNames(styles.bloc)}>

  		              <Trigger name="Annuler" onClick={handleCancelButton3} variant="tailwind2" />

                      &nbsp;&nbsp;&nbsp;&nbsp;

  		              <Trigger name={isEditMode?"Enregistrer":"Créer"} onClick={handleSaveButton} variant="tailwind2" />

					  &nbsp;&nbsp;

					  {
					   fieldsAreModified &&
					   ( <p className={classNames(styles.alert)} > N'oubliez pas d'enregistrer vos modifications </p> )
					  }

                    </div>

                  </div>

                </div>

			  </div>

           </div>

         );


};


export default SalesCampaignSheet;